export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-gray-50">
      <h1 className="text-7xl font-bold text-blue-600">404</h1>
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mt-6">Page Not Found</h2>
      <p className="mt-4 text-lg text-gray-600 max-w-md">
        Sorry, the page you're looking for doesn't exist or may have moved.
      </p>
      <a
        href="/"
        className="mt-8 inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
      >
        Return to Homepage
      </a>
    </div>
  );
}
